import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from '@/app/App.vue'
import { i18n, setupLocale } from '@/app/i18n'
import { router } from '@/router'
import { useAuthStore } from '@/stores/auth.store'
import { useThemeStore } from '@/stores/theme.store'
import '@/assets/styles/main.scss'

setupLocale()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia).use(router).use(i18n)

// Apply the persisted light/dark theme to <html> before the first paint, so the fullscreen
// loader (and everything else) renders in the correct theme from frame one.
useThemeStore(pinia)

// Kick off session restore early. The router guard also awaits it, and ensureSessionLoaded is
// single-flight, so exactly one /auth/me fires. We mount immediately (no await) so App.vue can
// show the fullscreen loader while /auth/me is in flight instead of blocking the first paint.
void useAuthStore(pinia).ensureSessionLoaded()

app.mount('#app')
